// Lib
import { first, last, split } from 'lodash/fp';

const splitSlash = split('/');
const splitQuery = split('?');

const getFilenameFromUrl = (url: string, fileType: string): string => {
    const lastPart = (last(splitSlash(url)) as string) ?? '';
    const filename = (first(splitQuery(lastPart)) as string) ?? '';

    if (filename.indexOf('.') > -1) return filename;

    const extension = (last(splitSlash(fileType)) as string) ?? '';
    return `${filename}.${extension}`;
};

export default getFilenameFromUrl;
